var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[`group-14`, _vm.className || ``]},[_c('img',{staticClass:"rectangle-7-2",attrs:{"src":_vm.rectangle73,"alt":"Rectangle 73"}}),_c('img',{staticClass:"rectangle-7-2 variant-1",attrs:{"src":_vm.rectangle76,"alt":"Rectangle 76"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }